import { SetValueETargetValue } from "../../Services/service"
import { CustomTextField } from "./CustomTextField"

export const Cus_TF = ({id, placeholder, name, value, setValue, sx, hidden, className, type}) => {
    return (
        <CustomTextField className={className} margin="normal" fullWidth id={id} focusColor="#c4960c" type={type ? type : "text"} 
            placeholder={placeholder} size="medium" name={name} autoComplete="username" value={value}
            sx={{ backgroundColor: "white",  
                    "&.MuiTextField-root": 
                        {
                            marginTop: "5px", 
                            marginBottom: "5px",
                        },
                    ...sx,
                }}
            onChange={(e) => { SetValueETargetValue(e.target.value, setValue) }}
        />
    )
}